import { type Common } from '../common.js';
import { type FindAllOptions, type LlmModel } from '../models/assistant/llmModel.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/llm-models';
  }

  async findAll(options: FindAllOptions): Promise<LlmModel[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }
}
